
import React, { useEffect, useState } from 'react';
import { Calendar, momentLocalizer,Views } from 'react-big-calendar';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import Layout from '../../Components/Layout/Layout';
import CalendarFilters from '../../Components/CalendarFilters/Index';
import './Style.css';
import CalenderModals from '../../Components/Modals/Index';
import axios from "axios";
import { APIUrlEICI, APIUrlToken } from '../../Utils/Utils'
import { toast } from 'react-toastify';
import Loader from '../../Components/Loader/Loader';
import { useNavigate } from 'react-router-dom';
import workweek from '../../Assets/workweek.png'
const localizer = momentLocalizer(moment);
const CustomToolbar = ({ label, onNavigate, onView, view,toggleWorkWeek,setToggleWorkWeek }) => {

  return (
    <>
    <div className='bc-ei-ww-btn'>
     <button onClick={() => {
        setToggleWorkWeek(!toggleWorkWeek);
        onView(!toggleWorkWeek ? "work_week" : "week");
      }}>
        <img src={workweek} alt="workweek" />
        {toggleWorkWeek ? "Full Week View" : "Business Days Only"}
      </button>
      </div>
    <div className="rbc-toolbar">
      <div className="toolbar-left">
        <button className='prev-button-cal' type="button" onClick={() => onNavigate('PREV')}>&lt;</button>
        <button className='next-button-cal' type="button" onClick={() => onNavigate('NEXT')}>&gt;</button>
        <button className='today-button-cal' type="button" onClick={() => onNavigate('TODAY')}>Today</button>
      </div>
      <div className="toolbar-center">
        <span className="rbc-toolbar-label">{label}</span>
      </div>
      <div className="toolbar-right">
        <button className={`prev-button-cal ${view === 'month' ? 'active-eici' : ''}`} type="button" onClick={() => onView('month')}>Month</button>
        {
          toggleWorkWeek ? 
          <button className={view === 'work_week' ? 'active-eici' : ''} type="button" onClick={() => onView('work_week')}>Week</button> : 
          <button className={view === 'week' ? 'active-eici' : ''} type="button" onClick={() => onView('week')}>Week</button>
        }
        <button className={view === 'day' ? 'active-eici' : ''} type="button" onClick={() => onView('day')}>Day</button>
        <button className={`next-button-cal ${view === 'agenda' ? 'active-eici' : ''}`} type="button" onClick={() => onView('agenda')}>List</button>
      </div>
    </div>
    </>
  );
};
const CustomAgenda = ({ events }) => {
  return (
    <div className="p-4">
      <h2 className="text-lg font-bold mb-3">Custom Agenda</h2>
      <table className="w-full border-collapse border border-gray-300">
        <thead>
          <tr className="bg-gray-200">
            <th className="border border-gray-300 px-4 py-2">Date</th>
            <th className="border border-gray-300 px-4 py-2">Event</th>
            <th className="border border-gray-300 px-4 py-2">Time</th>
          </tr>
        </thead>
        <tbody>
          {events.length > 0 ? (
            events.map((event) => (
              <tr key={event.id}>
                <td className="border border-gray-300 px-4 py-2">
                  {moment(event.start).format("YYYY-MM-DD")}
                </td>
                <td className="border border-gray-300 px-4 py-2">{event.title}</td>
                <td className="border border-gray-300 px-4 py-2">
                  {moment(event.start).format("hh:mm A")} -{" "}
                  {moment(event.end).format("hh:mm A")}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="3" className="text-center p-2">
                No events scheduled.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

const Dashboard = () => {  
  const navigate = useNavigate()
  const [events, setEvents] = useState([]);
  const [currentDate, setCurrentDate] = useState(new Date());

  const [modalOpen, setModalOpen] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [loading, setLoading] = React.useState(false);
  const [calendarView, setCalendarView] = useState('work_week');
  const [toggleWorkWeek,setToggleWorkWeek] =useState(true)
  const [selectedFilters, setSelectedFilters] = React.useState({
    years: [],
    months: [],
    associateList: [],
    categoriesList: [],
    teamList:[]
  })

  const [commingFilters, setComingFilters] = React.useState({
    years: [],
    months: [],
    associateList: [],
    categoriesList: [],
    teamList:[]
  });
  
  const [allcommingFilters, setAllComingFilters] = React.useState({
    years: [],
    months: [],
    associateList: [],
    categoriesList: [],
    teamList:[]
  });
  
  function generateRandomHexCode() {
    const r = Math.floor(Math.random() * 56) + 200;
    const g = Math.floor(Math.random() * 56) + 200;
    const b = Math.floor(Math.random() * 56) + 200;
    const a = 0.9;
    return `rgba(${r}, ${g}, ${b}, ${a})`;
  }

  // Get Calendar data 
  const getEventsList = () => {
    setLoading(true);
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "Authorization": APIUrlToken()
      },
      url: `${APIUrlEICI()}/eici_data`,
    };
    axios(option)
      .then((e) => {
        
        const data = e?.data?.map(item => ({
          id: item?.event_id,
          title: item?.subject,
          start: new Date(item?.start_datetime),
          end: new Date(item?.end_datetime),
          desc: `${item?.primary_attendees !== null ? item?.primary_attendees?.map(i=>i?.attendee_name).join(", "):item?.organizer_name}${item?.categories?.length ? `-(${item?.categories?.map(i=>i).join(", ")})` :""}-${item?.subject}`,
          // desc: `${item?.primary_attendees !== null ? item?.primary_attendees?.map(i=>i?.attendee_name).join(", "):item?.organizer_name}`,
          categories:item?.categories ,
          title:item?.subject ,
          // desc: `${item?.primary_attendees !== null ? item?.primary_attendees?.map(i=>i?.attendee_name).join(", "):item?.organizer_name}${item?.categories?.length ? "\n": ""}${item?.categories?.map(i=>i).join(", ")}\n${item?.subject}`,
          backgroundColor: generateRandomHexCode(),
          textColor: '#2d0057',
        }))
        let filteredData=data?.filter(i=>!i?.desc?.includes("JobsOhio Engagement Calendar"))
        setEvents(filteredData);
        setLoading(false);
      })
      .catch((e) => {
        toast.error(e?.response?.data?.message)
        // navigate("/")
      });
  };

  // Get Data by Id 
  const getEventById = (id) => {
    setLoading(true)
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "Authorization": APIUrlToken()
      },
      url: `${APIUrlEICI()}/eici_data_by_id/${id}`,
    };
    axios(option)
      .then((e) => {
        const data = e?.data
        setSelectedEvent(data);
        setLoading(false)
        setModalOpen(true);
      })
      .catch(() => { });
  }
  const handleEventClick = (event) => {
    getEventById(event?.id)
  };
  const handleModalClose = () => {
    setModalOpen(false);
    setSelectedEvent(null);
  };
  const eventPropGetter = (event) => ({
    style: {
      backgroundColor: event.backgroundColor,
      color: event.textColor,
      padding: '5px 5px',
      border: 'none',
    },
    draggable: false,
  });
  const handleViewChange = (view) => {
    setCalendarView(view);
  };
  const getMonthIndex = (monthName) => {
    const monthMap = {
      January: 0,
      February: 1,
      March: 2,
      April: 3,
      May: 4,
      June: 5,
      July: 6,
      August: 7,
      September: 8,
      October: 9,
      November: 10,
      December: 11,
    };
    return monthMap[monthName];
  };
  // Apply Filter Api 
  const handleApplyFilter = (e) => {
    const months = selectedFilters?.months;
    const years = selectedFilters?.years;
  
    // Prevent filtering if month selected without a year
    if (months?.length && (!years || !years.length)) {
      toast.error("Please select a year when selecting a month.");
      return;
    }
  
    setLoading(true);
  
    const data = {
      year: years,
      month: months,
      associate: selectedFilters?.associateList,
      category: selectedFilters?.categoriesList,
      teams: selectedFilters?.teamList,
    };
  
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "Authorization": `${APIUrlToken()}`,
      },
      url: `${APIUrlEICI()}/eici_apply_filter`,
      data: JSON.stringify(data),
    };
  
    axios(option)
      .then((e) => {
        setLoading(false);
        const events = e?.data?.map(item => ({
          id: item?.event_id,
          title: item?.subject,
          start: new Date(item?.start_datetime),
          end: new Date(item?.end_datetime),
          desc: `${item?.primary_attendees !== null ? item?.primary_attendees?.map(i => i?.attendee_name).join(", ") : item?.organizer_name}${item?.categories?.length ? `-(${item?.categories?.join(", ")})` : ""}-${item?.subject}`,
          backgroundColor: generateRandomHexCode(),
          textColor: '#2d0057',
        }));
  
        const filteredData = events?.filter(i => !i?.desc?.includes("JobsOhio Engagement Calendar"));
        setEvents(filteredData);
        const monthIndexes = months?.map(getMonthIndex); 
        const hasMonths = monthIndexes?.length > 0;
        const hasYears = years?.length > 0;
        
        if (hasYears) {
    setCalendarView('month')
    const earliestYear = Math.min(...years.map(Number));
    const earliestMonth = hasMonths ? Math.min(...monthIndexes) : 0;
    const targetDate = new Date(earliestYear, earliestMonth);
    setCurrentDate(targetDate);
  }
  
  
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err?.response?.data?.message);
      });
  };

  // Get Filter Data 
  const getCalendarFilters = () => {
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "Authorization": `${APIUrlToken()}`
      },
      url: `${APIUrlEICI()}/eici_filter_list`,
    };
    axios(option)
      .then((e) => {

        const data = e?.data;
        setComingFilters(data);
        setAllComingFilters(data);
      })
      .catch(() => { });
  };

  // Reset Button 
  const handleClearFilters = () => {
    setLoading(true);
    getEventsList();
    getCalendarFilters();
    setSelectedFilters({
      years: [],
      months: [],
      associateList: [],
      categoriesList: [],
      teamList:[]
    });
    setCurrentDate(new Date());
    setTimeout(() => {
      setLoading(false);
    }, 500);
  };
  React.useEffect(() => {
    getEventsList();
  }, []);
  useEffect(()=>{
    if(events?.length){
      getCalendarFilters();
    }
  },[events])
  const teamsFilter = [
    { "name": "Ian Andrew", "department": "Business Development" },
    { "name": "Alina Harastasanu", "department": "Business Development" },
    { "name": "Justin Kocher", "department": "Business Development" },
    { "name": "Ben Park", "department": "Business Development" },
    { "name": "Charlie Rowell", "department": "Business Development" },
    { "name": "Jordan Tyler", "department": "Business Development" },
    { "name": "Darnita Bradley", "department": "Government Affairs" },
    { "name": "Andrew Cooper", "department": "Government Affairs" },
    { "name": "Jessica Moline", "department": "Government Affairs" },
    { "name": "Lenee Pezzano", "department": "Government Affairs" },
    { "name": "Chris Abrams", "department": "Sector" },
    { "name": "Tyler Allchin", "department": "Sector" },
    { "name": "Karthik Avadhanula", "department": "Sector" },
    { "name": "Ryan Blackburn", "department": "Sector" },
    { "name": "Dave Brewster", "department": "Sector" },
    { "name": "Jonathan Bridges", "department": "Sector" },
    { "name": "Kevin Chambers", "department": "Sector" },
    { "name": "Matt Cybulski", "department": "Sector" },
    { "name": "Tim Derickson", "department": "Sector" },
    { "name": "Michael Dustman", "department": "Sector" },
    { "name": "Josh Hoffman", "department": "Sector" },
    { "name": "Glenn Richardson", "department": "Sector" },
    { "name": "Ron Rock", "department": "Sector" },
    { "name": "Meg Ryan", "department": "Sector" }
  ];

  useEffect(()=>{
if(selectedFilters?.teamList?.length){
  const filteredAssociate=teamsFilter?.filter(i=>selectedFilters?.teamList?.includes(i?.department))?.map(i=>i?.name)
  setComingFilters({...commingFilters, associateList:filteredAssociate})
  setSelectedFilters({...selectedFilters,associateList:[]})
}else{
  setComingFilters({...commingFilters,associateList:allcommingFilters?.associateList})
}
  },[selectedFilters?.teamList])
  return (
    <>
      {loading ? <Loader /> : null}
      <Layout>
        <CalendarFilters onView={handleViewChange} selectedFilters={selectedFilters} setSelectedFilters={setSelectedFilters} handleApplyFilter={handleApplyFilter} handleClearFilters={handleClearFilters} commingFilters={commingFilters} setComingFilters={setComingFilters} />
        <div className="main-container-calendar">
        <Calendar
  localizer={localizer}
  events={events}
  startAccessor="start"
  endAccessor="end"
  style={{ height: '100%' }}
  eventPropGetter={eventPropGetter}
  view={calendarView}
  onView={setCalendarView}
  date={currentDate} // 👈 auto-scroll to correct month
  onNavigate={setCurrentDate}
  popup
  views={Object.keys(Views).map((k) => Views[k])}
  handleDragStart={() => {}}
  components={{
    toolbar: (props) => (
      <CustomToolbar
        {...props}
        toggleWorkWeek={toggleWorkWeek}
        setToggleWorkWeek={setToggleWorkWeek}
      />
    ),
    event: ({ event }) => (
      <div
        className="custom-event"
        onClick={() => handleEventClick(event)}
      >
        <span>{event.desc}</span>
      </div>
    ),
    agenda: CustomAgenda,
  }}
  min={new Date(2024, 0, 1, 8, 0)}
  max={new Date(2024, 0, 1, 23, 59)}
/>
        </div>
        <CalenderModals
          open={modalOpen}
          onClose={handleModalClose}
          event={selectedEvent}
        />
      </Layout>
    </>
  );
};
export default Dashboard;



// import React, { useState } from 'react';
// import { Calendar, momentLocalizer } from 'react-big-calendar';
// import moment from 'moment';
// import 'react-big-calendar/lib/css/react-big-calendar.css';
// import Layout from '../../Components/Layout/Layout';
// import CalendarFilters from '../../Components/CalendarFilters/Index';
// import './Style.css';
// import CalenderModals from '../../Components/Modals/Index';
// import axios from "axios";
// import { APIUrlEICI, APIUrlToken } from '../../Utils/Utils'
// import { toast } from 'react-toastify';
// import Loader from '../../Components/Loader/Loader';
// import { useNavigate } from 'react-router-dom';
// const localizer = momentLocalizer(moment);
// const CustomToolbar = ({ label, onNavigate, onView, view }) => {
//   return (
//     <div className="rbc-toolbar">
//       <div className="toolbar-left">
//         <button className='prev-button-cal' type="button" onClick={() => onNavigate('PREV')}>&lt;</button>
//         <button className='next-button-cal' type="button" onClick={() => onNavigate('NEXT')}>&gt;</button>
//         <button className='today-button-cal' type="button" onClick={() => onNavigate('TODAY')}>Today</button>
//       </div>
//       <div className="toolbar-center">
//         <span className="rbc-toolbar-label">{label}</span>
//       </div>
//       <div className="toolbar-right">
//         <button className={`prev-button-cal ${view === 'month' ? 'active-eici' : ''}`} type="button" onClick={() => onView('month')}>Month</button>
//         <button className={view === 'week' ? 'active-eici' : ''} type="button" onClick={() => onView('week')}>Week</button>
//         <button className={view === 'day' ? 'active-eici' : ''} type="button" onClick={() => onView('day')}>Day</button>
//         <button className={`next-button-cal ${view === 'agenda' ? 'active-eici' : ''}`} type="button" onClick={() => onView('agenda')}>List</button>
//       </div>
//     </div>
//   );
// };
// const Dashboard = () => {
//   const navigate = useNavigate()
//   const [events, setEvents] = useState([]);
//   const [modalOpen, setModalOpen] = useState(false);
//   const [selectedEvent, setSelectedEvent] = useState(null);
//   const [loading, setLoading] = React.useState(false);
//   const [calendarView, setCalendarView] = useState('month');


//   const [showMoreEvents, setShowMoreEvents] = useState([]);
  
//   const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });

//   const handleShowMore = (events, date, e) => {
//     if (!e || !e.target) {
//       console.error("No target element for getBoundingClientRect");
//       return;
//     }
  
//     const rect = e.target.getBoundingClientRect();
//     setDropdownPosition({ top: rect.bottom + window.scrollY, left: rect.left + window.scrollX });
  
//     console.log("Original Events:", events); // Debug: Check unsorted data
  
//     const sortedEvents = [...events].sort((a, b) => {
//       const titleA = a.title || ""; // Fallback if title is missing
//       const titleB = b.title || "";
//       return titleA.localeCompare(titleB);
//     });
  
//     console.log("Sorted Events:", sortedEvents); // Debug: Check sorted data
  
//     setShowMoreEvents([...sortedEvents]); // Force state update with new reference
//   };
  
//   React.useEffect(() => {
//     console.log("Updated showMoreEvents:", showMoreEvents);
//   }, [showMoreEvents]);

  
//   const [selectedFilters, setSelectedFilters] = React.useState({
//     years: [],
//     months: [],
//     associateList: [],
//     categoriesList: [],
//   })
//   const [commingFilters, setComingFilters] = React.useState({
//     years: [],
//     months: [],
//     associateList: [],
//     categoriesList: [],
//   });
//   const predefinedCategoryColors = {
//     "Event - Ribbon Cutting": "rgba(255, 182, 193, 0.5)", 
//     "PTO": "rgba(173, 216, 230, 0.5)", 
//     "BR&E": "rgba(255, 239, 186, 0.5)",
//     "Event - Speaking Engagement/Panel": "rgba(175, 238, 238, 0.5)", 
//     "Event": "rgba(216, 191, 216, 0.5)", 
//     "Conference": "rgba(255, 218, 185, 0.5)", 
//     "Meeting": "rgba(220, 220, 220, 0.5)", 
//     "Red category": "rgba(255, 160, 122, 0.5)",
//     "Meeting with Govt/Legislature": "rgba(255, 228, 181, 0.5)", 
//     "Offsite": "rgba(173, 216, 230, 0.5)", 
//     "Event - Sponsorship": "rgba(240, 128, 128, 0.5)", 
//     "Event - Groundbreaking": "rgba(144, 238, 144, 0.5)",
//     "Event - JON": "rgba(221, 160, 221, 0.5)", 
//     "Conferences": "rgba(176, 224, 230, 0.5)", 
//     "Travel": "rgba(135, 206, 250, 0.5)", 
//     "Holiday": "rgba(255, 248, 220, 0.5)",
//   };
  

//   const categoryColorMap = {};
//   function generateRandomHexCode() {
//     const r = Math.floor(Math.random() * 56) + 200;
//     const g = Math.floor(Math.random() * 56) + 200;
//     const b = Math.floor(Math.random() * 56) + 200;
//     const a = 0.9;
//     return `rgba(${r}, ${g}, ${b}, ${a})`;
//   }
//  function getCategoryColor(categories) {
//   if (!categories || categories.length === 0) return generateRandomHexCode();
//   const category = categories[0];
//   if (!categoryColorMap[category]) {
//     categoryColorMap[category] = predefinedCategoryColors[category] || generateRandomHexCode();
//   }
//   return categoryColorMap[category];
// }

// // Generate Calendar Data
// const getEventsList = () => {
//   setLoading(true);
//   const option = {
//     method: "GET",
//     headers: {
//       "access-control-allow-origin": "*",
//       "content-type": "application/json",
//       "Authorization": APIUrlToken()
//     },
//     url: `${APIUrlEICI()}/eici_data`,
//   };
//   axios(option)
//     .then((e) => {
//       const data = e?.data?.map(item => {
//         const backgroundColor = getCategoryColor(item?.categories);
//         return {
//           id: item?.event_id,
//           title: item?.subject,
//           start: new Date(item?.start_datetime),
//           end: new Date(item?.end_datetime),
//           desc: `${
//             item?.primary_attendees !== null
//               ? item?.primary_attendees?.map(i => i?.attendee_name).join(", ")
//               : item?.organizer_name
//           } - ${item?.categories?.join(", ")}`,
//           backgroundColor,
//           textColor: '#2d0057',
//         };
//       });
//       setEvents(data);
//       setLoading(false);
//     })
//     .catch((e) => {
//       toast.error(e?.response?.data?.message);
//       navigate("/");
//     });
// }
//   React.useEffect(() => {
//     getEventsList();
//   }, []);
//   // Get Data by Id 
//   const getEventById = (id) => {
//     const option = {
//       method: "GET",
//       headers: {
//         "access-control-allow-origin": "*",
//         "content-type": "application/json",
//         "Authorization": APIUrlToken()
//       },
//       url: `${APIUrlEICI()}/eici_data_by_id/${id}`,
//     };
//     axios(option)
//       .then((e) => {
//         const data = e?.data
//         setSelectedEvent(data);
//         setModalOpen(true);
//       })
//       .catch(() => { });
//   }
//   const handleEventClick = (event) => {
//     getEventById(event?.id)
//   };
//   const handleModalClose = () => {
//     setModalOpen(false);
//     setSelectedEvent(null);
//   };
//   const eventPropGetter = (event) => ({
//     style: {
//       backgroundColor: event.backgroundColor,
//       color: event.textColor,
//       padding: '5px 5px',
//       border: 'none',
//     },
//     draggable: false,
//   });
//   const handleViewChange = (view) => {
//     setCalendarView(view);
//   };
//   // Apply Filter Api 
//   const handleApplyFilter = (e) => {
//     setLoading(true);
//     const data = {};
//     data.year = selectedFilters?.years;
//     data.month = selectedFilters?.months;
//     data.associate = selectedFilters?.associateList;
//     data.category = selectedFilters?.categoriesList;
//     const option = {
//       method: "POST",
//       headers: {
//         "access-control-allow-origin": "*",
//         "content-type": "application/json",
//         "Authorization": `${APIUrlToken()}`
//       },
//       url: `${APIUrlEICI()}/eici_apply_filter`,
//       data: JSON.stringify(data),
//     };
//     axios(option)
//     .then((response) => {
//       setLoading(false);
//       const filteredData = response?.data?.map(item => {
//         const backgroundColor = getCategoryColor(item?.categories);
//         return {
//           id: item?.event_id,
//           title: item?.organizer_name,
//           start: new Date(item?.start_datetime),
//           end: new Date(item?.end_datetime),
//           desc: item?.subject,
//           backgroundColor,
//           textColor: '#2d0057',
//         };
//       });
//       setEvents(filteredData);
//     })
//       .catch((err) => {
//         setLoading(false);
//         toast.error(err?.response?.data?.message);
//       });
//   };
  
//   // Get Filter Data 
//   const getCalendarFilters = () => {
//     const option = {
//       method: "GET",
//       headers: {
//         "access-control-allow-origin": "*",
//         "content-type": "application/json",
//         "Authorization": `${APIUrlToken()}`
//       },
//       url: `${APIUrlEICI()}/eici_filter_list`,
//     };
//     axios(option)
//       .then((e) => {
//         const data = e?.data;
//         setComingFilters(data);
//       })
//       .catch(() => { });
//   };
//   React.useEffect(() => {
//     getCalendarFilters();
//   }, []);
//   // Reset Button 
//   const handleClearFilters = () => {
//     setLoading(true);
//     getEventsList();
//     getCalendarFilters();
//     setSelectedFilters({
//       years: [],
//       months: [],
//       associateList: [],
//       categoriesList: [],
//     });
//     setTimeout(() => {
//       setLoading(false);
//     }, 500);
//   };
//   return (
//     <>
//       {loading ? <Loader /> : null}
//       <Layout>
//         <CalendarFilters onView={handleViewChange} selectedFilters={selectedFilters} setSelectedFilters={setSelectedFilters} handleApplyFilter={handleApplyFilter} handleClearFilters={handleClearFilters} commingFilters={commingFilters} setComingFilters={setComingFilters} />
//         <div className="main-container-calendar">
//           <Calendar
//             localizer={localizer}
//             events={events}
//             startAccessor="start"
//             endAccessor="end"
//             style={{ height: '100%' }}
//             eventPropGetter={eventPropGetter}
//             view={calendarView}
//             onView={setCalendarView}
//             popup
//             onShowMore={handleShowMore}
//             handleDragStart={()=>{}}
//             components={{
//               toolbar: CustomToolbar,
//               event: ({ event }) => (
//                 <div
//                   className="custom-event"
//                   onClick={() => handleEventClick(event)}
//                 >
//                   <span>{event.desc}</span>
//                 </div>
//               ),
//             }}
//             min={new Date(2024, 0, 1, 8, 0)}
//             max={new Date(2024, 0, 1, 23, 59)}
//           />
//         </div>

//         {showMoreEvents.length > 0 && (
//           <div
//             className="custom-dropdown"
//             style={{
//               position: 'absolute',
//               top: `${dropdownPosition.top}px`,
//               left: `${dropdownPosition.left}px`,
//               zIndex: 1000,
//               backgroundColor: '#fff',
//               boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
//               borderRadius: '4px',
//               padding: '10px',
//             }}
//           >
//             <div className="dropdown-header">More Events</div>
//             {showMoreEvents.map((event, index) => {
//   console.log(`Dropdown Event ${index}:`, event.title); // Verify rendering order
//   return (
//     <div
//       key={index}
//       className="dropdown-event"
//       onClick={() => handleEventClick(event)}
//     >
//       {event.title} - {event.desc}
//     </div>
//   );
// })}
//           </div>
//         )}

//         <CalenderModals
//           open={modalOpen}
//           onClose={handleModalClose}
//           event={selectedEvent}
//         />
//       </Layout>
//     </>
//   );
// };
// export default Dashboard;


